<template>
  <ScheduleDialog
    :open="open"
    title="Remover bloqueio"
    @close="close"
  >
    <p class="sw-unblock__text">
      Remover este bloqueio da agenda{{ label ? ` (${label})` : '' }}?
    </p>
    <p v-if="error" class="sw-unblock__error">{{ error }}</p>
    <template #footer>
      <button type="button" class="sw-unblock__btn" :disabled="loading" @click="close">Fechar</button>
      <button type="button" class="sw-unblock__btn is-danger" :disabled="loading" @click="submit">
        {{ loading ? 'Removendo…' : 'Remover' }}
      </button>
    </template>
  </ScheduleDialog>
</template>

<script>
import http from '../../../helpers/http';
import Alert from '../../../helpers/alert';
import ScheduleDialog from './ScheduleDialog.vue';

export default {
  name: 'ScheduleUnblockModal',
  components: { ScheduleDialog },
  props: {
    open: { type: Boolean, default: false },
    blockIds: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    idProf: { default: null },
  },
  emits: ['close', 'saved'],
  data() {
    return {
      error: '',
      loading: false,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  watch: {
    open(value) {
      if (!value) return;
      this.error = '';
      this.loading = false;
    },
  },
  methods: {
    close() {
      if (this.loading) return;
      this.$emit('close');
    },
    submit() {
      const ids = (this.blockIds || []).filter((id) => id != null && id !== '');
      if (!this.idProf || !this.place?.id_place || !ids.length) {
        this.error = 'Não foi possível identificar o bloqueio.';
        return;
      }
      this.error = '';
      this.loading = true;
      Promise.all(ids.map((id) => (
        http.delete(`/places/${this.place.id_place}/professionals/${this.idProf}/availabilities-blocks/${id}`)
      ))).then(() => {
        this.loading = false;
        Alert.toastSuccess('Bloqueio removido com sucesso.');
        this.$emit('saved');
        this.$emit('close');
      }).catch((error) => {
        this.loading = false;
        this.error = error.response?.data?.message || 'Não foi possível remover o bloqueio.';
        Alert.toastError(this.error);
      });
    },
  },
};
</script>

<style scoped>
.sw-unblock__text {
  margin: 0;
  color: #181c32;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.4;
}
.sw-unblock__error {
  margin: 0.65rem 0 0;
  color: #f1416c;
  font-size: 0.8rem;
  font-weight: 600;
}
.sw-unblock__btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.4rem;
  margin: 0;
  padding: 0.45rem 0.95rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.5rem;
  background: #fff;
  color: #181c32;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  box-shadow: none;
  cursor: pointer;
}
.sw-unblock__btn:hover:not(:disabled) {
  border-color: #780f5a;
  color: #780f5a;
}
.sw-unblock__btn.is-danger {
  background: #780f5a;
  border-color: #780f5a;
  color: #fff;
}
.sw-unblock__btn.is-danger:hover:not(:disabled) {
  background: #65104c;
  border-color: #65104c;
  color: #fff;
}
.sw-unblock__btn:disabled {
  opacity: 0.65;
  cursor: default;
}
</style>
